module.exports = __webpack_public_path__ + "static/img/m_pro2.b92c5219.png";